export default __webpack_public_path__ + "static/media/favicon.f53c44ba.ico";